import { Injectable } from '@angular/core';

export interface CacheDef {
  url: string;
  page: number;
  image: any;
}
export class ImageCacheService {
private _cache: CacheDef[] = [];
constructor() {}
/**
 * @return {?}
 */
get cache(): CacheDef[] {
    return this._cache;
  }
/**
 * @param {?} url
 * @param {?} page
 * @return {?}
 */
getCache(url: string, page: number) {
    return this.cache.find(i => i.url === url && i.page === page);
  }
/**
 * @param {?} url
 * @param {?} page
 * @return {?}
 */
getImage(url: string, page: number) {
    const /** @type {?} */ c = this.getCache(url, page);
    return c ? c.image : null;
  }
/**
 * @param {?} url
 * @param {?} page
 * @param {?} image
 * @return {?}
 */
saveImage(url: string, page: number, image: any) {
    const /** @type {?} */ cache = this.getCache(url, page);
    if (cache) {
      cache.image = image;
    } else {
      this.cache.push({ url, page, image });
    }
  }
/**
 * @return {?}
 */
disposeCache() {
    this.cache.forEach(i => URL.revokeObjectURL(i.image.src));
    this._cache = [];
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ImageCacheService_tsickle_Closure_declarations() {
/** @type {?} */
ImageCacheService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ImageCacheService.ctorParameters;
/** @type {?} */
ImageCacheService.prototype._cache;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
